import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { useUserStore } from '@lib/store';
import { useAccountContext } from '@shared/hooks';
import { FormatUtils, PaletteUtils } from '@shared/utils';

const THEME = process.env.THEME;

interface AccountInfoProps {
  className?: string;
}

export const AccountInfo = (props: AccountInfoProps) => {
  const userStore = useUserStore();

  const { account, card } = useAccountContext();
  const { t } = useTranslation();

  if (!account || !card) return null;
  return (
    <ul className={clsx('my-0', props.className)}>
      <li
        className={clsx(
          'uppercase text-[14px] font-[600] flex flex-col justify-between leading-[24px] tracking-[0.5px]',
          PaletteUtils.isBordierPalette && '!text-[#dc291c]',
        )}
      >
        <span className={clsx('!text-[11px]', PaletteUtils.isBordierPalette ? '' : 'text-[#e5c496]')}>
          {t('sidebar.accountInfo.fields.currentSpend')}:
        </span>
        <span className={clsx(' text-[27px] pt-1 px-0 pb-3', PaletteUtils.isBordierPalette ? '' : 'text-[#e5c496]')}>
          {FormatUtils.formatAmount(account.currentSpend, account.currency)}
        </span>
      </li>
      <li className={clsx('text-sm flex justify-between leading-6 tracking-[0.5px]', !PaletteUtils.isBordierPalette && 'text-[#bdbdbd]')}>
        <span>{t('sidebar.accountInfo.fields.cardStatus')}:</span>
        <span className={clsx(PaletteUtils.isBordierPalette ? 'font-bold' : 'font-medium')}>{card.status}</span>
      </li>
      {THEME !== 'm2' && (
        <li className={clsx('text-sm flex justify-between leading-6 tracking-[0.5px]', !PaletteUtils.isBordierPalette && 'text-[#bdbdbd]')}>
          <span>{t('sidebar.accountInfo.fields.cardLimit')}:</span>
          <span className={clsx(PaletteUtils.isBordierPalette ? 'font-bold' : 'font-medium')}>
            {FormatUtils.formatAmount(account.limit, account.currency)}
          </span>
        </li>
      )}
      <li className={clsx('text-sm flex justify-between leading-6 tracking-[0.5px]', !PaletteUtils.isBordierPalette && 'text-[#bdbdbd]')}>
        <span>{t('sidebar.accountInfo.fields.availableToSpend')}:</span>
        <span className={clsx(PaletteUtils.isBordierPalette ? 'font-bold' : 'font-medium')}>
          {FormatUtils.formatAmount(account.availableToSpend, account.currency)}
        </span>
      </li>
      {!!userStore.data?.version && (
        <>
          <li className={clsx('text-sm flex justify-between leading-6 tracking-[0.5px]', !PaletteUtils.isBordierPalette && 'text-[#bdbdbd]')}>
            <span>{t('sidebar.accountInfo.fields.contactPhone')}:</span>
            <span>{formatPhoneNumberIntl('+' + card.contactPhoneNumber)}</span>
          </li>
          <li className={clsx('text-sm flex justify-between leading-6 tracking-[0.5px]', !PaletteUtils.isBordierPalette && 'text-[#bdbdbd]')}>
            <span>{t('sidebar.accountInfo.fields.securePhone')}:</span>
            <span>{formatPhoneNumberIntl('+' + card.securePhoneNumber)}</span>
          </li>
        </>
      )}
    </ul>
  );
};
